// zh_CN.js
plupload.addI18n({
	'Select files' : '选择文件:',
	'Add files to the upload queue and click the start button.' : '将文件添加到上传队列，然后点击“开始”按钮.',
	'Filename' : '文件名',
	'Status' : '状态',
	'Size' : '大小',
	'Add files' : '添加文件',
	'Stop current upload' : '停止当前文件的上传',
	'Start uploading queue' : '开始上传队列',
	'Uploaded %d/%d files': '上传第 %d/%d个文件',
	'N/A' : 'N/A',
	'Drag files here.' : '拖动文件到这里;',
	'File extension error.': '文件扩展名错误.',
	'File size error.': '文件大小错误.',
	'Init error.': '初始化错误.',
	'HTTP Error.': 'HTTP错误.',
	'Security error.': '安全错误.',
	'Generic error.': '一般错误.',
	'IO error.': 'IO错误.',
	'Stop upload': '停止上传',
	'Add Files': '添加文件',
	'Start upload': '开始上传',
	'%d files queued': '%d 文件列队.'
});


//////////////////
// WEBPACK FOOTER
// ./static/plugin/plupload/zh_CN.js
// module id = Nkol
// module chunks = 1